import { NgModule } from '@angular/core';

@NgModule({
    imports: [],
    declarations: [],
    bootstrap: [],
    providers: [],
    exports: [],
})
export class EcmPortfolioModule {}
